import { render, staticRenderFns } from "./mycurriculum.vue?vue&type=template&id=2f7ad67d&scoped=true"
import script from "./mycurriculum.vue?vue&type=script&lang=js"
export * from "./mycurriculum.vue?vue&type=script&lang=js"
import style0 from "./mycurriculum.vue?vue&type=style&index=0&id=2f7ad67d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ad67d",
  null
  
)

export default component.exports